export enum ProjectStatusType {
    PROJECT_IDEA = 'Project idea',
    PROJECT_PLANNED = 'Project planned',
    ORDER_SENT = 'Offer sent to customer',
    PARTIAL_ORDER_RECEIVED = 'Partial order received',
    ORDER_RECEIVED = 'Order received',
    PROJECT_CLOSED = 'Project closed'
}
